if ( typeof ProductPage !== 'function' ) {

	// Mock KROWN object for testing
	if (typeof KROWN === 'undefined') {
		window.KROWN = {
			settings: {
				cart_action: 'overlay'
			}
		};
	}

	// Mock KEYCODES for testing
	if (typeof window.KEYCODES === 'undefined') {
		window.KEYCODES = {
			RETURN: 13
		};
	}

	class ProductPage extends HTMLElement {

		constructor(){

			super();

			this.productGallery = this.querySelector('[data-js-product-gallery]');
			this.productSlider = this.querySelector('css-slider');

			this.pickupAvailabilityExtended = this.querySelector('pickup-availability-extended');

			// Initialize addon functionality
			this.initializeAddons();

			// Initialize addon display for current variant on page load
			this.initializeAddonDisplay();

			// Gallery thumbnails

			if ( this.productSlider ) {

				const productGaleryThumbnails = this.querySelector('.product-gallery__thumbnails-holder');

				if ( this.querySelector('.product-gallery__thumbnails .thumbnail') ) {

					this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm, i)=>{
						if ( i == 0 )  {
							elm.classList.add('active');
						}
						elm.addEventListener('click',e=>{
							if ( this.productSlider.sliderEnabled ) {
								this.productSlider.changeSlide(e.currentTarget.dataset.index);
							} else {
								window.scrollTo({
									top: this.productGallery.querySelector(`.product-gallery-item[data-index="${e.currentTarget.dataset.index}"]`).getBoundingClientRect().top,
									behavior: 'smooth'
								});
								this.thumbnailNavigationHelper(e.currentTarget.dataset.index);
							}
							this._pauseAllMedia();
							this._playMedia(this.productGallery.querySelector(`.product-gallery-item[data-index="${e.currentTarget.dataset.index}"]`));
							productGaleryThumbnails.scrollTo({
								left: elm.offsetLeft - 50,
								behaviour: 'smooth'
							})
						});
					})

					this.productSlider.addEventListener('change', e=>{
						this.thumbnailNavigationHelper(e.target.index);
					});

				}

				this.productSlider.addEventListener('navigation', e=>{
					this._playMedia(this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`));
				})
				this.productSlider.addEventListener('change', e=>{
					this._pauseAllMedia();
					if ( this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`).dataset.productMediaType == 'model' ) {
						if ( this.xrButton ) {
							this.xrButton.setAttribute('data-shopify-model3d-id', this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`).dataset.mediaId);
						}
						setTimeout(()=>{
							this.productSlider.querySelector('.css-slider-holder').classList.add('css-slider--disable-dragging');
						}, 150);
					}
				});

				// Parallax

				this.productSlider.addEventListener('ready', (e)=>{
					if ( this.firstProductGalleryIndex ) {
						this.productSlider.changeSlide(this.firstProductGalleryIndex, "auto");
					}
				});

			}

			// Product variant event listener for theme specific logic

			this.productVariants = this.querySelector('product-variants[data-main-product-variants]');
			if ( this.productVariants ) {

				this.productVariants.addEventListener('VARIANT_CHANGE', this.onVariantChangeHandler.bind(this));
				this.onVariantChangeHandler({target:this.productVariants});

				// refresh color
				this.querySelectorAll('.product-variant__item--radio input').forEach(input=>{
					input.addEventListener('click', () => {
						const inputParent = input.closest('.product-variant__item--radio');
						if ( inputParent.classList.contains('product-variant__item--color' ) ) {
							inputParent.closest('.product-variant').querySelector('.product-variant__item-text-label').textContent = input.value;
						}
					})
				});

			}

			// show cart drawer when element is added to cart

			if ( ! document.body.classList.contains('template-cart') && KROWN.settings.cart_action == 'overlay' ) {
				
				let addToCartEnter = false;
				if ( this.querySelector('[data-js-product-add-to-cart]') ) {
					this.querySelector('[data-js-product-add-to-cart]').addEventListener('keyup', e=>{
						if ( e.keyCode == window.KEYCODES.RETURN ) {
							addToCartEnter = true;
						}
					})
				}	

				if ( this.querySelector('[data-js-product-form]') ) {
					this.querySelector('[data-js-product-form]').addEventListener('add-to-cart', ()=>{
						document.getElementById('site-cart-sidebar').show();
							if ( document.getElementById('cart-recommendations-sidebar') ) {
							document.getElementById('cart-recommendations-sidebar').generateRecommendations();
						}
						if ( addToCartEnter ) {
							setTimeout(()=>{
								document.querySelector('#site-cart-sidebar [data-js-close]').focus();
							}, 200);
						}
					});
				}

			}

			// Check for models

			const models = this.querySelectorAll('product-model');
			if ( models.length > 0 ) {
				window.ProductModel.loadShopifyXR();
				this.xrButton = this.querySelector('.product-gallery__view-in-space');
			}

			// hide buy now button if stock disabled

			const addToCartButton = this.querySelector('[data-js-product-add-to-cart][data-main-product-add-to-cart]');
			if ( addToCartButton ) {
				if ( addToCartButton.classList.contains('disabled') ) {
					this.querySelector('product-form').classList.add('disable-buy-button');
				} else {
					this.querySelector('product-form').classList.remove('disable-buy-button');
				}
				const buyObserver = new MutationObserver(()=>{
					if ( addToCartButton.classList.contains('disabled') ) {
						this.querySelector('product-form').classList.add('disable-buy-button');
					} else {
						this.querySelector('product-form').classList.remove('disable-buy-button');
					}
				});
				buyObserver.observe(addToCartButton,{ attributes: true, childList: false, subtree: false });
			}

		}

		thumbnailNavigationHelper(index=0){
			this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm, i)=>{
				if ( i == index )
					elm.classList.add('active');
				else 
					elm.classList.remove('active');
			});
		}

		onVariantChangeHandler(e){

			let variant = e.target.currentVariant;
			if ( variant ) {
				
				// image handling

				if ( variant.featured_media != null ) {
					let variantImg = this.productGallery.querySelector('.product-gallery-item[data-media-id="' + variant.featured_media.id + '"]');
					if ( variantImg ) {
						if ( this.productGallery.classList.contains('product-gallery--slider') || ( this.productGallery.classList.contains('product-gallery--scroll') && window.innerWidth < 1024 ) ) {
							if ( this.productGallery.querySelector('css-slider') && this.productGallery.querySelector('css-slider').sliderEnabled ) {
								this.productGallery.querySelector('css-slider').changeSlide(variantImg.dataset.index);
							} else {
								this.firstProductGalleryIndex = variantImg.dataset.index;
							}
						} else {
							if ( variantImg.getBoundingClientRect().top > window.innerHeight ) {		
								variantImg.scrollIntoView({behavior: 'smooth', block: 'center'});
							} else if ( variantImg.getBoundingClientRect().top < 0 ) {
								variantImg.scrollIntoView({behavior: 'smooth', block: 'center'});
							}
						}
					}
				}
				
				// variant addons handling
				this.handleVariantAddons(variant.id);
				
				this.querySelectorAll('.product-variant__item--color [data-selected]').forEach(elm=>{
					elm.closest('.product-variant').querySelector('.product-variant__item-text-label').textContent = elm.value;
				});

			}

		}

		handleVariantAddons(variantId) {
			// Hide all variant addons first
			this.querySelectorAll('.variant-addons').forEach(addon => {
				addon.classList.remove('show');
			});

			// Show the addon for the current variant
			const currentVariantAddon = this.querySelector(`.variant-addons[data-variant-id="${variantId}"]`);
			if (currentVariantAddon) {
				currentVariantAddon.classList.add('show');
			}
		}

		initializeAddons() {
			// Set up event listeners for addon checkboxes and quantity selectors
			this.addEventListener('change', (e) => {
				if (e.target.classList.contains('addon-checkbox') || e.target.classList.contains('addon-quantity')) {
					this.handleAddonChange(e);
				}
			});

			// Override the main product form submission to include addons
			const productForm = this.querySelector('[data-js-product-form]');
			if (productForm) {
				productForm.addEventListener('submit', (e) => {
					e.preventDefault();
					this.handleProductWithAddonsSubmit(e);
				});
			}
		}

		initializeAddonDisplay() {
			// Get the current variant ID from the product variants component
			const productVariants = this.querySelector('product-variants[data-main-product-variants]');
			if (productVariants && productVariants.currentVariant) {
				this.handleVariantAddons(productVariants.currentVariant.id);
			} else {
				// Fallback: look for the first visible addon container
				const firstVisibleAddon = this.querySelector('.variant-addons.show');
				if (firstVisibleAddon) {
					const variantId = firstVisibleAddon.dataset.variantId;
					if (variantId) {
						this.handleVariantAddons(variantId);
					}
				}
			}
		}

		handleAddonChange(e) {
			// This method can be used for real-time updates if needed
			// For now, we'll handle everything on form submission
		}

		handleProductWithAddonsSubmit(e) {
			console.log('🛒 Form submission started');
			const form = e.target;
			const formData = new FormData(form);
			
			// Get main product data
			const mainProductId = formData.get('id');
			const mainProductQuantity = parseInt(formData.get('quantity') || '1');

			console.log('📋 Form data:', {
				mainProductId,
				mainProductQuantity,
				formDataEntries: Array.from(formData.entries())
			});

			// Collect selected addons
			const selectedAddons = this.getSelectedAddons();
			console.log('🎯 Selected addons:', selectedAddons);

			// Prepare items array for cart
			const items = [
				{
					id: mainProductId,
					quantity: mainProductQuantity
				}
			];

			// Add selected addons to items array
			selectedAddons.forEach(addon => {
				items.push({
					id: addon.variantId,
					quantity: addon.quantity
				});
			});

			console.log('📦 Final items array:', items);

			// Add all items to cart
			this.addItemsToCart(items, form);
		}

		getSelectedAddons() {
			console.log('🔍 Getting selected addons...');
			const addons = [];
			const visibleAddonContainer = this.querySelector('.variant-addons.show');
			console.log('📍 Visible addon container:', visibleAddonContainer);
			
			if (visibleAddonContainer) {
				const checkedBoxes = visibleAddonContainer.querySelectorAll('.addon-checkbox:checked');
				console.log('✅ Checked boxes found:', checkedBoxes.length);
				
				checkedBoxes.forEach((checkbox, index) => {
					const addonItem = checkbox.closest('.addon-item');
					const quantitySelect = addonItem.querySelector('.addon-quantity');
					const variantId = checkbox.dataset.id;
					const quantity = parseInt(quantitySelect.value);
					
					console.log(`📋 Addon ${index + 1}:`, {
						variantId,
						quantity,
						checkboxElement: checkbox,
						quantityElement: quantitySelect
					});
					
					addons.push({
						variantId: variantId,
						quantity: quantity
					});
				});
			}
			
			console.log('🎯 Final selected addons:', addons);
			return addons;
		}

		addItemsToCart(items, form) {
			console.log('Adding items to cart:', items);
			
			const requestBody = {
				items: items
			};

			fetch(window.Shopify.routes.root + 'cart/add.js', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'X-Requested-With': 'XMLHttpRequest'
				},
				body: JSON.stringify(requestBody)
			})
			.then(response => {
				console.log('Cart API response status:', response.status);
				if (response.ok) {
					return response.json();
				} else {
					// Try to get error details
					return response.text().then(text => {
						console.error('Cart API error response:', text);
						throw new Error(`Failed to add items to cart: ${response.status} - ${text}`);
					});
				}
			})
			.then(data => {
				console.log('Cart API success response:', data);
				
				// Trigger the add-to-cart event for theme compatibility
				form.dispatchEvent(new CustomEvent('add-to-cart', {
					bubbles: true,
					detail: { items: data.items || data }
				}));
				
				// Update cart UI if needed
				if (typeof window.KROWN !== 'undefined' && window.KROWN.cart) {
					window.KROWN.cart.updateCartCount();
				}
				
				// Force cart drawer to show if available
				if (document.getElementById('site-cart-sidebar')) {
					document.getElementById('site-cart-sidebar').show();
				}
			})
			.catch(error => {
				console.error('Error adding items to cart:', error);
				// Show user-friendly error message
				alert('There was an error adding items to cart. Please try again.');
			});
		}

		_pauseAllMedia(){

			document.querySelectorAll('.product-gallery .js-youtube').forEach(video => {
				video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
			});
			document.querySelectorAll('.product-gallery .js-vimeo').forEach(video => {
				video.contentWindow.postMessage('{"method":"pause"}', '*');
			});
			document.querySelectorAll('.product-gallery video').forEach(video => video.pause());
			document.querySelectorAll('.product-gallery product-model').forEach(model => {
				if ( model.modelViewerUI ) 
					model.modelViewerUI.pause()
			});
		}
		
		_playMedia(media){
			switch ( media.dataset.productMediaType ) {
				case 'video':
					if ( media.querySelector('video') ) {
						media.querySelector('video').play();
					}
					break;
				case 'external_video-youtube':
					if ( media.querySelector('.js-youtube') ) {
						media.querySelector('.js-youtube').contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
					}
					break;
				case 'external_video-vimeo':
					if ( media.querySelector('.js-vimeo') ) {
						media.querySelector('.js-vimeo').contentWindow.postMessage('{"method":"play"}', '*');
					}
					break;
			}
		}

	}

  if ( typeof customElements.get('product-page') == 'undefined' ) {
		customElements.define('product-page', ProductPage);
	}

}